export class BaseModel {
  Id: number;
  Active: boolean = true;
}
